export default __webpack_public_path__ + "static/media/grant.30dcc4ca.mp3";